import { portalRoutes } from "@/router/routes/portalRoutes";

const PARTNER_BASE_ROUTE = "/partner";

/** Whether a router path belongs to the partner app, its welcome page included. */
export const isPartnerPath = (pathname: string) =>
  pathname.startsWith(PARTNER_BASE_ROUTE) ||
  pathname.startsWith(portalRoutes.welcomePartner);

/** The same check for code outside the router, read from the hash route. */
export const isPartnerHashRoute = () =>
  isPartnerPath(window.location.hash.replace(/^#/, ""));
